import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule, LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Subscription } from 'rxjs';
import { EmptyObject, WebUtils } from '../common/utils';
import { AccessUtils, SpaceFacilityFee, TBooking, TSpace, inviteLink } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SitePathMixin } from '../core/site.path.utils';
import { SessionCache } from '../session.cache';
import { SessionService } from '../session.service';
import { BookingCalendarUtils } from '../thinkdesks/booking.calendar.utils';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { TBookingStatus } from '../thinkdesks/thinkdesks.entities';
import { BookingSharingService } from './booking.sharing';
import { SpaceCard } from './space.card';

@Component({
  selector: 'app-my-booking-completed-page',
  standalone: true,
  imports: [CommonModule, SpaceCard, FontAwesomeModule, MatMenuModule],
  templateUrl: './my.booking.completed.page.html',
})
export class MyBookingCompletedPage extends SiteLangMixin(
  SiteFormatMixin(SitePathMixin(EmptyObject))
) {
  @HostBinding('class') css = 'max-scroll';
  susbcription: Subscription;
  id: number;

  _common = _common;

  fees = SpaceFacilityFee;
  object: TBooking;
  statusList = TBookingStatus;

  openingHours: string[] = [];
  // clipboard: any;
  // snackBar: any;
  constructor(
    public sharing: BookingSharingService,
    private locationStrategy: LocationStrategy,
    private route: ActivatedRoute,
    private router: Router,
    public override session: SessionService,
    private cache: SessionCache,
    private http: HttpClient,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
  ) {
    super();
  }
  ngOnInit() {
    if (!this.session.user) {
      this.router.navigate([this.session.path('/')]);
      return;
    }
    this.susbcription = this.route.paramMap.subscribe((result) => {
      this.id = parseInt(result.get('id'));
      this.refresh();
    });
  }
  ngOnDestroy() {
    this.susbcription.unsubscribe();
  }


  refresh() {
    window.scrollTo(0, 0);

    WebUtils.web_result(
      this.http.get(`/api/public/booking/retrieve/${this.id}`),
      async (result) => {
        this.object = result;
        AccessUtils.fixBooking(this.object);
        AccessUtils.fixSpace(this.object.space as TSpace);
        let location = this.object.space?.location;
        let s = this.lang(location?.openingHours, location?.openingHours_lang);
        this.openingHours = s.split('\n');

        if (this.object.numParticipants)
          this.inviteUrl = await this.inviteLink();
      },
      null,
      (err) => {
        this.router.navigate([this.session.path('/')]);
      }
    );
  }
  googleCalendar() {
    BookingCalendarUtils.googleCalendar(this.locationStrategy, this.object);
  }
  bookAgain() {
    this.router.navigate([`/space/${this.object.space.id}`]);
  }
  copyPasscode() {
    this.clipboard.copy(this.object.passcode);
    this.snackBar.open(_common.copied);
  }

  inviteUrl: string;
  async inviteLink() {
    let url = inviteLink(this.session.lang, this.object);

    return url;
  }

  isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || ('ontouchstart' in window)
      || navigator.maxTouchPoints > 0;
  }

  smartShare(object: any) {
    if (this.isMobileDevice()) {
      // Mobile browser → use native share or your mobile-specific link
      this.sharing.share_toApp(object);
    } else {
      // Desktop → open Web Share or fallback link
      this.sharing.share(object);
    }
  }



}
